module.exports = __webpack_public_path__ + "assets/img/Nava Park.82e8fbe1.png";